export const UPDATE_ENTITY = 'UPDATE_ENTITY'
